module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_01_sunset-e0914bb8f5410c00a39d3773c5d7369a.jpg";